<template lang="pug">
PageView(:title="title", :icon="titleIcon" :backLink="backLink" backText="Back to Tickets").subpage
  template(v-slot:id v-if="edit")
    id(:id="editData.id")
  template(v-slot:header-right)
    Button(@click="send", :loading="state === 'updating' || state === 'creating'" :class="`${state === 'updated' || state === 'created' ? 'green' : ''}`").m-r-2
      template(v-if="edit")
        template(v-if="state === ''") {{ $t(`products.update_${type}_type`) }}
        template(v-else-if="state === 'updating'") {{ $t(`products.updating_${type}_type`) }}
        template(v-else-if="state === 'updated'") {{ $t(`products.updated_${type}_type`) }}
      template(v-else)
        template(v-if="state === ''") {{ $t(`products.create_${type}_type`) }}
        template(v-else-if="state === 'creating'") {{ $t(`products.creating_${type}_type`) }}
        template(v-else-if="state === 'created'") {{ $t(`products.created_${type}_type`) }}
    dots.border.left.m-r-2(v-if="edit")
      ul
        li(@click.prevent="deleteProduct")
          i(class="icon-close-medium")
          | {{ $t(`products.remove_${type}`) }}
  Access(@data="!edit ? setAccess($event) : null",  ref="access", :edit="edit", :editData="{ id: editData.id, access: editData.access}", v-if="editData.type === 'stream' || type === 'stream'")
  Variations(@data="!edit ? setVariations($event) : null", ref="variations", :edit="edit", :editData="{ id: editData.id, sku: editData.sku, attributes: editData.attributes }", v-if="editData.type === 'good' || type === 'good'")
  Pricing(@data="!edit ? setPricing($event) : null", :subscriptions="editData.type === 'stream' || type === 'stream'", ref="pricing", :editData="{ id: editData.id, prices: editData.prices }", :priceRequired="editData.type === 'stream' || type === 'stream'" :edit="edit").m-t-4
  Information(@data="!edit ? setInformation($event) : null", ref="information", :edit="edit" :editData="editData").m-t-4
  template(v-slot:side)
    // ProductImage(:edit="edit", @data="!edit ? setImages($event) : null" ref="images", :editData="{ id: editData.id, images: editData.images }" v-if="editData.type === 'good' || type === 'good'")
    MediaUpload(@images="!edit ? setImages($event) : null", customText="Upload new image", :multiple="true", ref="images", :data="{ edit, id: editData.id || null, action: 'Products/updateImages', images: editData.images }", v-if="editData.type === 'good' || type === 'good'")
  template(v-slot:bottom)
    template(v-if="productNotValid")
      p.error {{ $t('products.correct_errors') }}
    .d-f.ai-c
      template(v-if="edit")
        p.ml-a.color-alert.text-underline.text-hover(@click.prevent="deleteProduct") {{ $t(`products.remove_${type}`) }}
</template>

<script>

import Dots from '@/components/Dots.vue';
import Access from '@/partials/Products/Access.vue';
import Information from '@/partials/Products/Information.vue';
import Pricing from '@/partials/Products/Pricing.vue';
import Variations from '@/partials/Products/Variations.vue';
import ProductImage from '@/partials/Products/Image.vue';
import MediaUpload from '@/components/MediaUpload.vue';

export default {
  components: {
    Access,
    Information,
    Pricing,
    Variations,
    ProductImage,
    MediaUpload,
    Dots,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      validator: value => ['stream', 'good', 'service'].indexOf(value) !== -1,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    title() {
      const { edit, type } = this;
      return edit ? this.$t(`products.view_${type}_type`) : this.$t(`products.create_${type}_type`);
    },
    titleIcon() {
      const { type } = this;
      switch (type) {
        case 'stream':
          return 'ticket';
        case 'good':
          return 'package-variant-closed';
        case 'service':
          return '';
        default:
          return '';
      }
    },
  },
  methods: {
    setAccess(data) {
      if (data !== null) {
        this.product.access = data;
      } else {
        delete this.product.access;
      }
    },
    setPricing(data) {
      this.product.price = data;
    },
    setInformation(data) {
      Object.assign(this.product, data);
    },
    setVariations(variations) {
      if (variations === null) {
        this.product.sku = [];
        this.product.attributes = [];
      } else {
        const { variations: sku, attributes } = variations;
        Object.assign(this.product, {
          sku,
          attributes,
        });
      }
    },
    setImages(images) {
      this.product.images = images.map(image => image.value);
    },
    async send() {
      const { edit } = this;
      this.productNotValid = false;

      let valid = true;
      // eslint-disable-next-line
      for (const property in this.$refs) {
        // eslint-disable-next-line
        const answer = await this.$refs[property].validate();
        if (!answer) {
          valid = false;
        }
      }

      if (!valid) {
        this.productNotValid = true;
        this.state = '';
        return;
      }

      if (edit) {
        this.state = 'updating';

        // eslint-disable-next-line
        for (const property in this.$refs) {
          // eslint-disable-next-line
          await this.$refs[property].update();
        }

        this.$emit('updated', true);
        this.state = 'updated';

        setTimeout(() => {
          this.state = '';
        }, 2000);

        // eslint-disable-next-line
        for (const property in this.$refs) {
          // eslint-disable-next-line
          if (typeof this.$refs[property].reset !== 'undefined') {
            // eslint-disable-next-line
            await this.$refs[property].reset();
          }
        }

        return;
      }

      this.state = 'creating';

      const { product: orig } = this;
      const product = JSON.parse(JSON.stringify(orig));

      product.active = true;

      const result = await this.$store.dispatch('Products/createProduct', product);

      if (!result) {
        this.state = '';
        return;
      }

      this.state = 'created';

      setTimeout(() => {
        this.$router.push(`/ticket/${result.id}`);
      }, 2000);
    },
    async deleteProduct() {
      const { type, editData: { id } } = this;
      const willDelete = await swal({
        title: this.$t('errors.are_you_sure'), text: this.$t(`products.delete_${type}_warning`), icon: 'warning', buttons: true, dangerMode: true,
      });
      if (!willDelete) return;

      const doesIt = await this.$store.dispatch('Products/deleteProduct', id);
      if (!doesIt) {
        swal({ title: this.$t('errors.error_occured'), text: this.$t(`products.${type}_removed_error`), icon: 'error' });
        return;
      }

      this.$router.push('/tickets');
    },
    reset() {
      // eslint-disable-next-line
      for (const property in this.$refs) {
        // eslint-disable-next-line
        if (typeof this.$refs[property].reset === 'function') {
          this.$refs[property].reset();
        }
      }
    },
  },
  data() {
    return {
      state: '',
      productNotValid: false,
      backLink: '/tickets',
      product: {
        name: '',
        attributes: [],
        type: null,
        price: [],
        sku: [],
      },
    };
  },
  async mounted() {
    await this.$store.dispatch('AccountManager/getCountryCurrencies');
    if (!this.edit) {
      this.product.type = this.type;
    }

    const lastRoute = this.$store.getters['Theme/lastRoute'];
    if (lastRoute && lastRoute.path.includes('tickets')) {
      this.backLink = lastRoute.fullPath;
    }
  },
};
</script>

<style lang="scss" scoped>
p.error {
  color: #414141;
  font-size: 1.5rem;
  margin-bottom: 26px;
}
</style>
